import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { CourtsApiService } from 'src/app/core/services/api/courts-api.service';
import { cities } from '../../models/cities';
import { countries } from '../../models/countries';
import { Court } from '../../models/courts/court';
import { NgSelectProps } from '../../models/ng-select-props';

@Component({
  selector: 'app-court-create-edit',
  templateUrl: './court-create-edit.component.html',
  styleUrls: ['./court-create-edit.component.scss']
})
export class CourtCreateEditComponent implements OnInit {
  public court: Court;
  public cities = cities;
  public countries = countries;

  public cityNgSelect = null;

  @ViewChild('courtsModal') courtsModal;
  @Output() submit: EventEmitter<Court> = new EventEmitter<Court>();

  modalRef: NgbModalRef;

  constructor(private modalService: NgbModal,
    private api: CourtsApiService,
    private spinner: NgxSpinnerService,) {
    this.cityNgSelect = new NgSelectProps(this.api.getCities);
  }

  ngOnInit(): void {
    this.cityNgSelect.loadItems();
  }

  // handle the popup
  open(court: Court) {
    this.court = Object.assign(new Court(), court);
    this.modalRef = this.modalService.open(this.courtsModal, { centered: true, size: 'lg' });
  }

  close() {
    this.modalRef.close();
  }

  onSubmit() {
    this.spinner.show();
    const url = this.court.id ? this.api.updateCourt(this.court) : this.api.createCourt(this.court);
    url.subscribe(
      c => {
        this.spinner.hide();
        this.submit.emit(c);
      }
    );
  }

  searchFn() {
    return true;
  }
}

